import React from "react";
import { Outlet } from "react-router-dom";

const WithoutNavigationBar: React.FC = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default WithoutNavigationBar;
